<template>
  <v-card class="ma-3">
    <v-card-title>
      <h2>{{ title }}</h2>
    </v-card-title>
    <v-card-title>
      <!-- <v-btn color="primary" @click="addNew"> {{$t('Add new')}} </v-btn> -->
      <v-btn color="primary" flat v-if="!rawData" @click="getRawData">
        <v-icon left>mdi-eye-off-outline</v-icon>
        {{ $t('Raw Data') }}
      </v-btn>
      <v-btn color="primary" flat v-if="rawData" @click="initialize">
        <v-icon left>mdi-eye-outline</v-icon>
        {{ $t('Raw Data') }}
      </v-btn>
      <v-btn color="primary" @click="newUser">
        <v-icon left>mdi-plus</v-icon>
        {{ $t('Nuevo usuario') }}
      </v-btn>

      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        :label="$t('Search')"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-card-title>
      <v-layout align-center justify-end row fill-height wrap slot="extension" class="white--text">
        <div class="ml-3">
          <v-select
            solo
            color="primary"
            v-model="activeOrUnactive"
            item-text="text"
            item-value="value"
            :items="[
              { text: 'Clientes activos', value: 'active' },
              { text: 'Clientes inactivos', value: 'inactive' },
              { text: 'Todos', value: 'all' },
            ]"
            row
          ></v-select>
        </div>
        <div class="ml-3">
          <v-select
            solo
            color="primary"
            v-model="showMyCustomers"
            item-text="text"
            item-value="value"
            :items="[
              { text: 'No filtrar', value: false },
              { text: 'Sólo mis clientes', value: true },
            ]"
            row
          ></v-select>
        </div>
        <div class="ml-3">
          <v-select
            solo
            color="primary"
            v-model="nonPaymentFilter"
            item-text="text"
            item-value="value"
            :items="[
              { text: 'No filtrar', value: '' },
              { text: 'Con impagos', value: 'true' },
              { text: 'Al corriente', value: 'false' },
            ]"
            label="Impagos"
            row
          ></v-select>
        </div>
        <!--      <div class="ml-3">-->
        <!--        <v-switch v-model="unreadMessages" :label="'Mostrar mensajes sin leer'"></v-switch>-->
        <!--      </div>-->
      </v-layout>
    </v-card-title>
    <v-dialog v-model="formDialog" max-width="650px">
      <!-- <empresa-form v-if="empresa == 'customer'" :edit-index="editedIndex" :edit-item="editedItem" @closeDialog="closeDialog" @empresaSaved="empresaSaved"></empresa-form> -->
      <link-aplifisa-to-user
        :item="itemToLink"
        @initialDataLoaded="loadUserData"
        @closeDialog="closeDialog"
        @fiscalSaved="fiscalSaved"
      ></link-aplifisa-to-user>
    </v-dialog>
    <v-dialog fullscreen v-model="aplifisaDetailDialog">
      <customer-data-form
        v-if="configLoaded && aplifisaDetailDialog"
        :config="config"
        :edit-index="editedIndex"
        :edit-item="editedItem"
        @closeDialog="closeAplifisaDetailDialog"
        @customerContractSaved="initialize()"
        @customerAdditionalDataSaved="initialize()"
      ></customer-data-form>
      <!-- <slot name="form" v-if="formDialog" :editItem="editedItem" :form-dialog="formDialog"></slot> -->
    </v-dialog>
    <v-dialog max-width="700" v-model="formCustomerUserDialog">
      <customer-user-form
        v-if="readyToEditUser && formCustomerUserDialog"
        :edit-index="editedIndex"
        :edit-item="editedItem"
        @closeDialog="formCustomerUserDialog = false"
        @profileSaved="profileSaved"
        @removeConsultant="removeConsultant($event)"
      ></customer-user-form>
      <!-- <slot name="form" v-if="formDialog" :editItem="editedItem" :form-dialog="formDialog"></slot> -->
    </v-dialog>
    <v-dialog fullscreen v-model="showChecklist">
      <customer-checklist
        v-if="editedItem"
        :key="editedItem.CLAVEDAT"
        :config="customerChecklistConfig"
        :clavedat="checklist_clavedat"
        :item="editedItem"
        @closeDialog="showChecklist = false"
        @checklistSaved="initialize()"
      ></customer-checklist>
      <!-- <slot name="form" v-if="formDialog" :editItem="editedItem" :form-dialog="formDialog"></slot> -->
    </v-dialog>
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="items"
      :pagination.sync="pagination"
      :rows-per-page-items="[10, 20, 30, 50, 100]"
      :total-items="pagination.totalItems"
    >
      <template slot="items" slot-scope="props">
        <td v-for="col of headers" :key="col.value">
          <template v-if="!Array.isArray(props.item[col.value])">
            <!-- <template v-if="col.value === 'checklist_value'">
              <v-tooltip top>
                <v-icon
                  slot="activator"
                  small
                  class="mr-2"
                  :class="checklistColorClass(props.item.customer_checklist)"
                  @click="openChecklist(props.item)"
                >
                  mdi-clipboard-check-outline
                </v-icon>

                <span>{{ $t('Checklist') }}</span>
              </v-tooltip>
              <span :class="checklistColorClass(props.item.customer_checklist)">
                {{ props.item.customer_checklist.checklist_report.total_checked }}/{{
                  props.item.customer_checklist.checklist_report.total_to_check
                }}
              </span>
            </template> -->
            <template v-if="col.value === 'modules'">
              <customer-modules-button
                v-model="props.item.customer_modules"
                :clavedat="props.item.CLAVEDAT"
                :verifactuModel="props.item.openbilling_profile"
                @synced-verifactu="initialize()"
                @form-saved="initialize()"
              ></customer-modules-button>
            </template>
            <template v-else-if="col.value === 'status'">
              <v-switch
                v-model="props.item.status"
                :label="props.item.status === 'active' ? 'SÍ' : 'NO'"
                false-value="inactive"
                true-value="active"
                @change="onChangeStatus(props.item.CLAVEDAT, props.item.status)"
              ></v-switch>
            </template>
            <template v-else-if="col.value === 'premium'">
              <v-switch
                v-model="props.item.premium"
                :label="props.item.premium === true || props.item.premium === 1 ? 'SÍ' : 'NO'"
                @change="onChangePremium(props.item.CLAVEDAT, props.item.premium)"
              ></v-switch>
            </template>
            <template v-else-if="col.value === 'non_payment'">
              <v-switch
                v-model="props.item.non_payment"
                color="error"
                :label="
                  props.item.non_payment === true || props.item.non_payment === 1 ? 'SÍ' : 'NO'
                "
                @change="onChangeNonPayment(props.item.CLAVEDAT, props.item.non_payment)"
              ></v-switch>
              <v-switch
                v-if="props.item.non_payment === true || props.item.non_payment === 1"
                v-model="props.item.non_payment_blocked"
                color="error"
                :label="
                  props.item.non_payment_blocked === true || props.item.non_payment_blocked === 1
                    ? 'Bloqueado'
                    : 'No bloqueado'
                "
                @change="
                  onChangeNonPaymentBlocked(props.item.CLAVEDAT, props.item.non_payment_blocked)
                "
              ></v-switch>
            </template>
            <template v-else-if="col.value === 'seguimiento'">
              <v-layout align-center>
                <v-switch
                  v-model="props.item.seguimiento"
                  color="success"
                  :label="
                    props.item.seguimiento === true || props.item.seguimiento === 1 ? 'SÍ' : 'NO'
                  "
                  @change="onChangeSeguimiento(props.item.CLAVEDAT, props.item.seguimiento)"
                ></v-switch>
                <!-- <v-tooltip top v-if="!props.item.seguimiento || props.item.seguimiento === 0">
                  <v-icon slot="activator" color="warning" class="ml-1">mdi-alert-circle</v-icon>
                  <span>{{ $t('Tiene tareas de activación pendientes') }}</span>
                </v-tooltip> -->
              </v-layout>
            </template>
            <template v-else-if="col.value == 'action'">
              <v-tooltip top>
                <v-icon
                  slot="activator"
                  small
                  class="mr-2"
                  color="grey"
                  @click="showAplifisaDetails(props.item)"
                >
                  mdi-eye
                </v-icon>
                <span>{{ $t('Ver datos de aplifisa') }}</span>
              </v-tooltip>
              <v-tooltip top>
                <v-icon
                  slot="activator"
                  small
                  class="mr-2"
                  color="grey"
                  @click="linkToUser(props.item)"
                >
                  mdi-account-plus
                </v-icon>
                <span>{{ $t('Link element to user') }}</span>
              </v-tooltip>
              <v-tooltip top>
                <v-icon
                  slot="activator"
                  small
                  class="mr-2"
                  :color="props.item.customer ? 'grey' : 'grey lighten-2'"
                  @click="props.item.customer ? editUser(props.item) : ''"
                >
                  mdi-account-edit
                </v-icon>
                <span>{{ $t('Edit user') }}</span>
              </v-tooltip>
            </template>
            <template v-else>
              {{ props.item[col.value] }}
            </template>
          </template>
          <template v-if="Array.isArray(props.item[col.value])">
            <template v-for="ob of props.item[col.value]">
              {{ ob }} &nbsp;
            </template>
          </template>
        </td>
      </template>
      <template slot="no-data">
        <v-btn color="primary" @click="initialize">{{ $t('Reset') }}</v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import EmpresaAPI from '../services/fiscal.js';
import LinkAplifisaToUser from './LinkAplifisaToUser.vue';
import CustomerModel from '@/modules/admin/customers-and-consultants/models/customer.js';

import CustomerDataForm from './CustomerDataForm.vue';
import CustomerUserForm from './CustomerUserForm.vue';
import CustomerChecklist from './CustomerChecklist.vue';
import CustomerModulesButton from './CustomerModulesButton.vue';

import ApiCtrl from '@/services/api/abstract/abstract-api.js';
import apiCtrl from '@/services/aru-services/aru-api.service';

export default {
  components: {
    LinkAplifisaToUser,
    CustomerDataForm,
    CustomerUserForm,
    CustomerChecklist,
    CustomerModulesButton,
  },
  props: ['title'],
  data() {
    return {
      search: '',
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 10, // -1 for All",
        sortBy: '',
        totalItems: 0,
      },
      loading: true,
      clavedat: '',
      items: [],
      readyToEditUser: false,
      formDialog: false,
      aplifisaDetailDialog: false,
      formCustomerUserDialog: false,
      configLoaded: false,
      editedItem: {},
      editedIndex: null,
      headers: [],
      rawData: false,
      initialCustomer: null,
      initialUserData: null,
      config: {},
      itemToLink: null,
      showChecklist: false,
      checklist_clavedat: null,
      contract_clavedat: null,
      sortTable: false,
      customerChecklistConfig: null,
      showMyCustomers: true,
      activeOrUnactive: 'active',
      nonPaymentFilter: '',
    };
  },

  mounted() {
    this.initialize();
  },
  computed: {
    currentPage() {
      return this.pagination.page;
    },
    perPage() {
      return this.pagination.rowsPerPage;
    },
    sortBy() {
      return this.pagination.sortBy;
    },
    descending() {
      return this.pagination.descending;
    },
  },
  methods: {
    initialize() {
      this.loading = true;
      this.rawData = false;
      this.getItems();
      this.getConfig();
      // this.editedItem = this.getEmptyEmpresaModel();
    },

    getItems() {
      this.loading = true;

      const config = {
        params: {
          page: this.pagination.page,
          per_page: this.pagination.rowsPerPage,
          search: this.search,
          sort_by: this.pagination.sortBy,
          descending: this.pagination.descending,
          myCustomers: this.showMyCustomers,
          status: this.activeOrUnactive,
          non_payment: this.nonPaymentFilter !== '' ? this.nonPaymentFilter : undefined,
        },
      };
      EmpresaAPI.getFiscalData(config).then(response => {
        // // console.log(response);
        this.items = response.data.data;

        this.structure = response.data.structure;
        this.headers = response.data.dataTable.headers;

        this.pagination = {
          descending: this.pagination.descending,
          page: this.pagination.page,
          rowsPerPage: Number(response.data.meta.per_page), // -1 for All",
          sortBy: this.pagination.sortBy,
          totalItems: Number(response.data.meta.total),
        };

        this.loading = false;
        // console.log(this.headers);
        // console.log(this.items);
      });
    },

    getItemsIfStopChanging() {
      this.loading = true;
      const params = {
        page: this.pagination.page,
        per_page: this.pagination.rowsPerPage,
        search: this.search,
      };

      setTimeout(() => {
        if (
          params.page === this.pagination.page &&
          params.per_page === this.pagination.rowsPerPage &&
          params.search === this.search
        ) {
          this.getItems();
        }
      }, 300);
    },

    getConfig() {
      this.configLoaded = false;
      const promises = [
        ApiCtrl.get('/config/fiscaldata'),
        ApiCtrl.get('/config/customer-checklist'),
        ApiCtrl.get('/config/customer-contract'),
      ];

      Promise.all(promises).then(multiRes => {
        console.log(multiRes);
        this.config = multiRes[0].data.data;
        this.customerChecklistConfig = multiRes[1].data.data;
        this.config.customerContract = multiRes[2].data.data;
        this.configLoaded = true;
      });

      // .then(res => {
      //   // console.log({ config: res });
      //   this.config = res.data.data;
      //   this.configLoaded = true;
      // });

      // ApiCtrl.get("/config/customer-checklist").then(res => {
      //   // console.log({ config: res });
      //   this.customerChecklistConfig = res.data.data;
      //   this.configLoaded = true;
      // });
    },

    getRawData() {
      this.loading = true;
      this.rawData = true;

      // this.editedItem = this.getEmptyEmpresaModel();

      EmpresaAPI.getFiscalDataRaw().then(response => {
        // console.log(response);

        this.items = response.data.data;

        this.structure = response.data.structure;
        this.headers = response.data.dataTable.headers;
        this.loading = false;
        // console.log(this.headers);
        // console.log(this.items);
      });
    },

    openChecklist(item) {
      this.showChecklist = true;
      this.checklist_clavedat = item.CLAVEDAT;
      this.editedItem = item;
      console.log('item', item);
    },

    linkToUser(item) {
      this.itemToLink = item;
      // this.editedIndex = this.items.indexOf(item);
      // console.log({INDEZ: this.items.indexOf(item)})
      // this.clavedat = item.CLAVEDAT;
      // if(item.customer) {
      //     // console.log('INITIAL CUSTOMER');
      //     // console.log(item.customer);
      //     this.initialCustomer = item.customer.id;

      // }
      // console.log({item: item, editedIndex: this.editedIndex, clavedat: item.CLAVEDAT});
      // this.editedindex =  Object.assign({}, item);
      // this.$emit('editItem', this.editedItem);
      this.formDialog = true;
    },

    editUser(item) {
      this.readyToEditUser = false;

      this.editedItem = null;
      // this.editedIndex = this.items.indexOf(item);
      // this.clavedat = item.CLAVEDAT;
      // if(item.customer) {
      //     // console.log('INITIAL CUSTOMER');
      //     // console.log(item.customer);
      //     this.initialCustomer = item.customer.id;

      // }
      // // console.log({item: item, editedIndex: this.editedIndex, clavedat: item.CLAVEDAT});
      // this.editedindex =  Object.assign({}, item);
      // this.$emit('editItem', this.editedItem);
      this.editedItem = item.customer;
      this.readyToEditUser = true;

      this.formCustomerUserDialog = true;
    },

    newUser() {
      // console.log("New User");
      this.readyToEditUser = false;

      this.editedItem = CustomerModel.CustomerModel();
      // console.log({ CUSTOMERMODEL: this.editedItem });
      this.formCustomerUserDialog = true;
      this.readyToEditUser = true;
    },

    showAplifisaDetails(item) {
      // console.log(item);
      this.editedItem = item;
      this.aplifisaDetailDialog = true;
    },

    addNew() {
      this.editedIndex = null;
      // this.editedItem = this.getEmptyEmpresaModel();
      this.formDialog = true;
    },
    closeDialog() {
      this.formDialog = false;
    },

    closeAplifisaDetailDialog() {
      this.aplifisaDetailDialog = false;
    },

    deleteItem(item) {
      const index = this.items.indexOf(item);
      confirm(this.$t('Are you sure you want to delete this item?')) && this.items.splice(index, 1);
      EmpresaAPI.deleteEmpresa(item.id).then(() => {
        // console.log(res);
      });
    },
    profileSaved() {
      // console.log(data);
      // if(data.index) {
      //     this.items.splice(data.index, 1, data.profile);
      // } else {
      //     this.items.push(data.profile);
      // }
      this.initialize();
      this.formCustomerUserDialog = false;
    },
    fiscalSaved() {
      // console.log('FISCAL SAVED');
      // console.log(data);
      // if(data.index || data.index === 0) {
      //     this.items.splice(data.index, 1, data.empresa);
      // } else {
      //     this.items.push(data.empresa);
      // }
      this.initialize();
      this.formDialog = false;
    },
    loadUserData(data) {
      this.initialUserData = data;
    },

    checklistColorClass(checklist) {
      if (checklist.checklist && checklist.checklist.incidencia_cobro) {
        return { 'red--text': true };
      }
      if (checklist.checklist_report.total_to_check === checklist.checklist_report.total_checked) {
        return { 'primary--text': true };
      } else {
        return { 'secondary--text': true };
      }
    },
    removeConsultant($event) {
      const index = this.editedItem.consultants.findIndex(
        consultant => consultant.id === $event.id,
      );
      this.editedItem.consultants.splice(index, 1);
    },
    onChangeStatus(clavedat, value) {
      console.log('change to', value);
      const data = {
        status: value,
      };

      try {
        apiCtrl.put(`/admin/aplifisa/fiscal/${clavedat}/status`, data);
      } catch (error) {
        console.log(error);
      }
    },
    onChangePremium(clavedat, value) {
      const data = {
        premium: value,
      };

      try {
        apiCtrl.put(`/customer-additional-data/clavedat/${clavedat}/premium`, data);
      } catch (error) {
        console.log(error);
      }
    },
    onChangeNonPayment(clavedat, value) {
      const data = {
        non_payment: value,
      };

      try {
        apiCtrl.put(`/customer-additional-data/clavedat/${clavedat}/non-payment`, data);
      } catch (error) {
        console.log(error);
      }
    },
    onChangeNonPaymentBlocked(clavedat, value) {
      const data = {
        non_payment_blocked: value,
      };

      try {
        apiCtrl.put(`/customer-additional-data/clavedat/${clavedat}/non-payment-blocked`, data);
      } catch (error) {
        console.log(error);
      }
    },
    onChangeSeguimiento(clavedat, value) {
      const data = {
        seguimiento: value,
      };

      try {
        apiCtrl.put(`/customer-additional-data/clavedat/${clavedat}/seguimiento`, data);
      } catch (error) {
        console.log(error);
      }
    },
  },
  watch: {
    search: function() {
      if (this.currentPage === 1) {
        this.getItemsIfStopChanging();
      } else {
        this.pagination.page = 1;
      }
    },
    currentPage: function() {
      this.getItemsIfStopChanging();
    },
    perPage: function() {
      if (this.currentPage === 1) {
        this.getItemsIfStopChanging();
      } else {
        this.pagination.page = 1;
      }
    },
    sortBy: function() {
      if (this.sortBy != null && this.sortTable) {
        this.getItems();
      } else {
        if (this.descending === null) {
          this.sortTable = false;
        }
      }
    },
    descending: function() {
      if (this.descending != null) {
        this.getItems();
        this.sortTable = true;
      } else {
        if (this.sortBy === null) {
          this.sortTable = false;
        }
      }
    },
    showMyCustomers: function() {
      this.getItems();
    },
    activeOrUnactive: function() {
      this.getItems();
    },
    nonPaymentFilter: function() {
      this.getItems();
    },
  },
};
</script>
